// removed by extract-text-webpack-plugin
module.exports = {"overlay":"c-MembershipOverlayPopup__overlay","background":"c-MembershipOverlayPopup__background","content":"c-MembershipOverlayPopup__content","close":"c-MembershipOverlayPopup__close"};


//////////////////
// WEBPACK FOOTER
// ./src/components/container/MembershipOverlayPopup/MembershipOverlayPopup.scss
// module id = 1096
// module chunks = 0